import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import {
  TrendingSeries,
  secondaryHeatGeneratorStatusValue,
  secondaryHeatGeneratorStatusValueColor,
} from '../../trending-chart.helpers';
import { TrendingStore, VisiblePlotBandFeature } from '@store';
import { CommonStandaloneModule } from 'src/app/shared/common-standalone.module';
import {
  MAT_CHECKBOX_DEFAULT_OPTIONS,
  MatCheckboxDefaultOptions,
  MatCheckboxModule,
} from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { EventNames } from 'src/app/shared/directives/prevent-event/event-names';
import { SharedDependenciesModule } from 'src/app/shared';
import { CustomTranslationsService } from 'src/app/operational-data-common/translations';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-trending-chart-legend-plot-band',
  standalone: true,
  imports: [CommonStandaloneModule, MatCheckboxModule, FormsModule, SharedDependenciesModule],
  templateUrl: './trending-chart-legend-plot-band.component.html',
  styleUrl: './trending-chart-legend-plot-band.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: MAT_CHECKBOX_DEFAULT_OPTIONS,
      useValue: { clickAction: 'noop' } as MatCheckboxDefaultOptions,
    },
  ],
})
export class TrendingChartLegendPlotBandComponent implements OnInit, OnDestroy {
  @Input({ required: true }) series: TrendingSeries;
  @Input({ required: true }) plotBandFeature: VisiblePlotBandFeature;

  readonly eventNames = EventNames;

  featureLabels: string[];
  feautreLabelColors: string[];

  protected ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    private trendingStore: TrendingStore,
    private cdRef: ChangeDetectorRef,
    private translations: CustomTranslationsService
  ) {}

  ngOnInit(): void {
    const featureName = this.series.options.id.split('_')[1];

    switch (featureName) {
      case 'heating.secondaryHeatGenerator.status/value':
        this.mapFeatureLabels(
          secondaryHeatGeneratorStatusValue,
          'TRENDING_PLOT_BAND_EXTERNAL_HEAT_GENERATOR',
          featureName
        );
        this.feautreLabelColors = Object.values(secondaryHeatGeneratorStatusValueColor);
    }
  }

  private mapFeatureLabels(
    featureLabels: Record<number, string>,
    baseString: string,
    featureName: string
  ): void {
    this.trendingStore.enumSeries$.subscribe((data) => {
      // Find proper enum_series feature in store
      const matchingSeries = data.find((series) => series.feature === featureName);
      const matchingSeriesValues: number[] = matchingSeries?.value;
      if (matchingSeriesValues?.length) {
        // Get unique values from enum (0, 1...) and filter out unused enum keys
        const uniqueValues = new Set(matchingSeriesValues);
        const existingFeatureLabels = new Array(...uniqueValues)
          .sort((a, b) => a - b)
          .map((id) => featureLabels[id]);

        this.featureLabels = existingFeatureLabels.map(
          (statusValue) => this.translations[baseString][statusValue]
        );
      }
    });
  }

  onPlotBandItemClick(): void {
    this.trendingStore.selectPlotBandFeature([this.plotBandFeature]);
    this.cdRef.detectChanges();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
